define(["dojo/i18n", "/mathworks/hub/share/apps/iat/javascript_build_harness/R2020b/2.18.7/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"/mathworks/devel/bat/BR2020bd/build/matlab/ui/webwidgets/src/l10n/nls/layout.js?absMid=l10n/nls/layout"
], function(loader, runner) {
   return runner(loader, "l10n/nls/layout", __webpack_require__.dj.c(), true);
});